module.exports = __webpack_public_path__ + "static/media/pause.d3653cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/pause.svg
// module id = 622
// module chunks = 0